<script setup>
import { defineEmits, defineProps } from "vue";
import SearchContact from "@/components/SearchContact.vue";

const props = defineProps({
  placeholder: { type: String, required: false, default: "Search contacts..." },
  value: { type: String, required: false, default: "" },
  autoShowResults: { type: Boolean, required: false, default: true },
  customerId: { type: [Number, String], required: false, default: null },
});

const emit = defineEmits(["selected"]);
</script>

<template>
  <SearchContact
    :placeholder="props.placeholder"
    :value="props.value"
    :autoShowResults="props.autoShowResults"
    :customerId="props.customerId"
    @selected="(val) => emit('selected', val)"
  />
</template>
